import { render, staticRenderFns } from "./IpaasProblemDialog.vue?vue&type=template&id=6a3d9e17&"
import script from "./IpaasProblemDialog.vue?vue&type=script&lang=js&"
export * from "./IpaasProblemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports